import React from 'react';

import DynamicStateService, { DynamicStateScopes } from '~features/DynamicStateService';

type AiInsightsChartDescriptionsStateUser = {
  enabled?: boolean;
};

// A key of its own, deliberately not the main dashboard's `ChartDescriptions`:
// AI Insights carries its own preference so hiding descriptions on one page
// never silently hides them on the other. User-scope patches are shallow-merged
// per top-level key, so the two live side by side without colliding.
type DynamicStateUserWithAiInsightsChartDescriptions = {
  AiInsightsChartDescriptions?: AiInsightsChartDescriptionsStateUser;
};

const DESCRIPTIONS_ENABLED_BY_DEFAULT = true;

function useAiInsightsChartDescriptionsState(): [boolean, (enabled: boolean) => void] {
  const [currentDynamicState, updateDynamicState] = DynamicStateService.useDynamicStateService<
    DynamicStateUserWithAiInsightsChartDescriptions,
    Record<string, never>
  >();

  const descriptionsEnabled =
    currentDynamicState?.user?.AiInsightsChartDescriptions?.enabled ?? DESCRIPTIONS_ENABLED_BY_DEFAULT;

  const updateDescriptionsEnabled = React.useCallback(
    (enabled: boolean) => {
      updateDynamicState({
        scope: DynamicStateScopes.User,
        state: {
          AiInsightsChartDescriptions: { enabled },
        },
      });
    },
    [updateDynamicState]
  );

  return [descriptionsEnabled, updateDescriptionsEnabled];
}

export default useAiInsightsChartDescriptionsState;
